const jsdiff = require('diff')

const difference = (rangeText, clauseText) => {
  const diff = jsdiff
    .diffWords(clauseText, rangeText)
    .filter(d => d.added && d.value.trim().length > 3)
  console.log('DIFF', diff)
  return diff
}

export default {
  difference
}



// WEBPACK FOOTER //
// ./src/service/diffService.js